/**
 * Search input event
 */
export interface SearchInputEvent {
    searchText?: string,
    type: 'CLOSE_RESULTS' | 'SEARCH_OPEN' | 'SEARCH_CLOSE' | 'SEARCH_CHANGED'
}
